import { TextFormatAlign } from "./TextFormatAlign";
// http://help.adobe.com/en_US/FlashPlatform/reference/actionscript/3/flash/text/TextFormat.html
// http://help.adobe.com/en_US/FlashPlatform/reference/actionscript/3/flash/text/TextLineMetrics.html
import { getLogger } from "@goodgamestudios/logger";
import { TEXT_FIELDS_LOGGER } from "../../../../../index";
import { currentBrowserInfo } from '../BrowserInfo';
const logger = getLogger(TEXT_FIELDS_LOGGER + ".TextFormat");
export class TextFormat {
    public blockIndent: number = 0;
    public bullet: boolean = false;
    public kerning: boolean = false;
    public letterSpacing: number = 0;
    public tabStops: number[];

    public static DEFAULT_SYSTEM_FONT: "sans_serif";

    constructor(public font: string = TextFormat.DEFAULT_SYSTEM_FONT, public size: number = 12, public color: string | number = "#000000", public bold: boolean = false, public italic: boolean = false, public underline: boolean = false, public url: string = "", public target: string = "", public align: string = TextFormatAlign.LEFT, public leftMargin: number = 0, public rightMargin: number = 0, public indent: number = 0, public leading: number = 0, public link: string | null = null) {}

    /**
     *  EaselJs  Text.font expect a css like description of the font therefore we need to "format" font size and style together in one string
     * @returns {string}
     */
    public get fontType() {
        if (!/^_?(Body|Header)Font$/.test(this.font)) {
            // TODO HTML5  HTML-2128  TEMPORARY DETECT EVERY EXCEPTION  and always use loaded font
            logger.info(`forcing ${this.font} to be  aliased to the loaded font  as _BodyFont  --> HTML-2168 `);
            this.font = currentBrowserInfo.isIE ? "BodyFont" : "_BodyFont";
        }

        let fontType: string = "";

        if (this.bold) {
            fontType += "Bold ";
        }
        if (this.italic) {
            fontType += "Italic ";
        }

        if (this.size != null) {
            fontType += this.size.toString() + "px ";
        } else {
            fontType += "12px ";
        }

        fontType += this.font;

        return fontType;
    }

    // todo convert number to string when color value is assigned
    // in current implementation every time we request color a new string is allocated
    get stringColor(): string {
        if (typeof this.color === "number") {
            return "#" + this.color;
        } else {
            return this.color;
        }
    }
}
